import React, { useEffect } from 'react';

import LoginPage from './pages/LoginPage';
import InspactPage from './pages/InspactPage';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import QrScanListener from './components/common/QrScanListener';
import { loadMyMenu } from './modules/coach/coach';
import { COACH_MENU_KEYS, isMenuHiddenForCoach } from './lib/def/coachMenu';

import LockerPage from './pages/locker/LockerPage';
import Configuration from './pages/configuration/center/Configuration';
import MemberPage from './pages/member/MemberPage';
import PrescriptionPage from './pages/prescription/PrescriptionPage';
import CenterRegistPage from './pages/configuration/center/CenterRegistPage';
import CoachConfigurationPage from './pages/configuration/coach/CoachConfigurationPage';
import DoorConfigurationPage from './pages/configuration/door/DoorConfigurationPage';
// import BarcodeConfigurationPage from './pages/configuration/barcode/BarcodeConfigurationPage'; // 잠정 숨김(소스 유지)
import ItemConfigurationPage from './pages/configuration/item/ItemConfigurationPage';
import CoachRegistPage from './pages/configuration/coach/CoachRegistPage';
import ItemRegistPage from './pages/configuration/item/ItemRegistPage';
import MemberListPage from './pages/member/MemberListPage';
import ClubMemberRegistPage from './pages/member/ClubMemberRegistPage';
import LockerSale from './pages/locker/LockerSale';
import DefaultClubRegistPage from './pages/DefaultClubRegistPage';
import RegistPage from './pages/prescription/RegistPage';
import SalesPage from './pages/sales/SalesPage';
import StatisticsPage from './pages/statistics/StatisticsPage';
import PointPage from './pages/point/PointPage';
import AttendPage from './pages/attend/AttendPage';
import PointRulePage from './pages/point/PointRulePage';
import ProgramPage from './pages/prescription/ProgramPage';
import ProgramRegistPage from './pages/prescription/ProgramRegistPage';
import AppMainPage from './pages/App/AppMainPage';
import BannerPage from './pages/App/BannerPage';
import BannerRegistPage from './pages/App/BannerRegistPage';
import NotificationMessagePage from './pages/App/NotificationMessagePage';
import LandingPage from './pages/App/LandingPage';
import LandingRegistPage from './pages/App/LandingRegistPage';
import ImageTemplatePage from './pages/App/ImageTemplatePage';
import ImageTemplateRegistPage from './pages/App/ImageTemplateRegistPage';
import ClubNewsPage from './pages/App/ClubNewsPage';
import AppManagementGuidePage from './pages/App/AppManagementGuidePage';
import MobileProductPage from './pages/App/MobileProductPage';
import MobileSalesUpPage from './pages/App/MobileSalesUpPage';
import AutoMessagePage from './pages/App/AutoMessagePage';
import MobileProductAdmissionPage from './pages/App/MobileProductAdmissionPage';
import MobileProductRegistPage from './pages/App/MobileProductRegistPage';
import KioskProductPage from './pages/App/KioskProductPage';
import KioskProductRegistPage from './pages/App/KioskProductRegistPage';
import KioskProductSettingPage from './pages/App/KioskProductSettingPage';
import CoachProfilePage from './pages/App/CoachProfilePage';
import CoachProfileModify from './pages/App/CoachProfileModifyPage';
import LessonPage from './pages/Lesson/LessonPage';
import LessonSettingPage from './pages/Lesson/LessonSettingPage';
import AdminPage from './pages/admin/AdminPage';
import CouponPage from './pages/coupon/CouponPage';
import SMSPage from './pages/App/SMSPage';
import RunningTrackPage from './pages/runningtrack/RunningTrackPage';
import RunningTrackMusicPage from './pages/runningtrack/RunningTrackMusicPage';
import RunningTrackMusicDownloadPage from './pages/runningtrack/RunningTrackMusicDownloadPage';
import RunningTrackLauncherDownloadPage from './pages/runningtrack/RunningTrackLauncherDownloadPage';
import EContractConfigurationPage from './pages/configuration/econtract/EContractConfigurationPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import KioskAttendCheckPage from './pages/kiosk/KioskAttendCheckPage';
import AttendAppPage from './pages/configuration/attendapp/AttendAppPage';

// CRM 접속권한 강사(memberType 6) 전용 메뉴 가드.
// 본인 메뉴 표시 설정(webMenuHidden)을 로드하고, 숨긴 메뉴의 라우트로 직접 접근하면 /member 로 리다이렉트한다.
// 관리 대상 메뉴(COACH_MENU_KEYS)가 아니거나, 비강사이거나, 설정 로드 전이면 통과(차단하지 않음).
const CoachMenuGuard = () => {
  const dispatch = useDispatch();
  const { user, defaultClub, myMenuHidden, myMenuLoaded, socketKey } = useSelector(
    ({ user, club, coach, socket }) => ({
      user: user.user,
      defaultClub: club.defaultClub,
      myMenuHidden: coach.myMenuHidden,
      myMenuLoaded: coach.myMenuLoaded,
      socketKey: socket.socketKey,
    }),
  );
  const location = useLocation();

  useEffect(() => {
    if (user && Number(user.memberType) === 6 && defaultClub && defaultClub.clubID) {
      dispatch(
        loadMyMenu({ clubID: defaultClub.clubID, playerID: user.playerID, socketKey }),
      );
    }
  }, [user, defaultClub, socketKey, dispatch]);

  if (!user || Number(user.memberType) !== 6) return null;
  if (!myMenuLoaded) return null; // 로드 전엔 차단하지 않음(깜빡임/오차단 방지)

  const seg = (location.pathname || '').split('/')[1];
  if (!seg || COACH_MENU_KEYS.indexOf(seg) === -1) return null; // 관리 대상 메뉴 아님 → 통과
  if (isMenuHiddenForCoach(seg, defaultClub, myMenuHidden)) {
    return <Redirect to="/member" />;
  }
  return null;
};

const App = () => {

  return (
    <>
      <QrScanListener />
      <CoachMenuGuard />
      <Route component={LoginPage} path={['/', '/login']} exact />
      <Route component={InspactPage} path={'/inspact'} exact />
      <Route component={PrescriptionPage} path="/prescription" exact />
      <Route component={RegistPage} path="/prescription/regist" exact />
      <Route component={ProgramPage} path="/prescription/program" exact />
      <Route component={ProgramRegistPage} path="/prescription/program/regist" exact />
      <Route component={LockerPage} path="/locker" exact />
      <Route component={DashboardPage} path="/dashboard" exact />
      {/* backward compatible */ }
      <Route component={DashboardPage} path="/center" exact />
      <Route component={Configuration} path={['/configuration/center']} exact />
      <Route component={AttendAppPage} path="/configuration/attendapp" exact />
      {/* <Route component={BarcodeConfigurationPage} path="/configuration/barcode" exact /> 잠정 숨김(소스 유지) */}
      <Route component={MemberPage} path="/member/@:playerID" />
      <Route component={MemberListPage} path="/member" exact />
      <Route component={ClubMemberRegistPage} path="/member/regist" />
      <Route component={LockerSale} path="/locker/sale" exact />
      <Route
        component={CenterRegistPage}
        path="/configuration/center/regist"
        exact
      />
      <Route
        component={CoachConfigurationPage}
        path="/configuration/coach/"
        exact
      />
      <Route
        component={DoorConfigurationPage}
        path="/configuration/door/"
        exact
      />
      <Route
        component={CoachRegistPage}
        path="/configuration/coach/regist"
        exact
      />
      <Route
        component={ItemConfigurationPage}
        path="/configuration/item/"
        exact
      />
      <Route
        component={EContractConfigurationPage}
        path="/configuration/econtract/"
        exact
      />
      <Route
        component={ItemRegistPage}
        path="/configuration/item/regist"
        exact
      />
      <Route component={AdminPage} path="/admin" exact />
      <Route component={SalesPage} path="/sales" exact />
      <Route component={RunningTrackPage} path="/runningtrack" exact />
      <Route component={RunningTrackMusicPage} path="/runningtrack/music" exact />
      <Route component={RunningTrackMusicDownloadPage} path="/runningtrack/musicdownload" exact />
      <Route component={RunningTrackLauncherDownloadPage} path="/runningtrack/launcherdownload" exact />
      <Route component={StatisticsPage} path="/statistics" exact />
      <Route component={LessonPage} path="/lesson" exact />
      <Route component={LessonSettingPage} path="/lesson/setting" exact />
      <Route component={PointPage} path="/point" exact />
      <Route component={AttendPage} path="/attend" exact />
      <Route component={AppMainPage} path="/mobile" exact />
      <Route component={CouponPage} path="/coupon" exact />
      <Route component={SMSPage} path="/mobile/sms" exact />
      <Route component={BannerPage} path="/mobile/banner" exact />
      <Route component={BannerRegistPage} path="/mobile/banner/regist" exact />
      <Route component={NotificationMessagePage} path="/mobile/message" exact />
      <Route component={CoachProfilePage} path="/mobile/coachProfile" exact />
      <Route component={CoachProfileModify} path="/mobile/coachProfile/modify" exact />
      <Route component={MobileProductAdmissionPage} path="/mobileProduct/admission" exact />
      <Route component={MobileSalesUpPage} path="/mobileProduct/salesUp" exact />
      <Route component={AutoMessagePage} path="/mobileProduct/salesUp/autoMessage" exact />
      <Route component={MobileProductPage} path="/mobileProduct" exact />
      <Route component={MobileProductRegistPage} path="/mobileProduct/regist" exact />
      <Route component={KioskProductPage} path="/kiosk/product" exact />
      <Route component={KioskProductRegistPage} path="/kiosk/product/regist" exact />
      <Route component={KioskProductSettingPage} path="/kiosk/product/setting" exact />
      <Route component={KioskAttendCheckPage} path="/attendmanager/:code" exact />
      <Route component={AppManagementGuidePage} path="/mobile/guide" exact />
      <Route component={LandingRegistPage} path="/mobile/landing/regist" exact />
      <Route component={LandingPage} path="/mobile/landing" exact />
      <Route component={ImageTemplatePage} path="/mobile/imageTemplate" exact />
      <Route component={ImageTemplateRegistPage} path="/mobile/imageTemplate/regist" exact />
      <Route component={ClubNewsPage} path="/mobile/clubNews" exact />
      <Route component={PointRulePage} path="/point/rule" exact />
      <Route component={DefaultClubRegistPage} path="/start" exact />
    </>
  );
};

export default App;
